export enum FONTS {
  h1Size = '1.75rem',
  h2Size = '1.5rem',
  h3Size = '1.25rem',
  h4Size = '1.125rem',
  p1Size = '1rem',
  p2Size = '0.875rem',
  p3Size = '0.75rem',
  p4Size = '0.5rem',

  iconSize0 = '2rem',
  iconSize0_9 = '0.9rem',
  iconSize1 = '1.5rem',
  iconSize1_15 = '1.15rem',
  iconSize2 = '1rem',
  iconSize3 = '0.875rem',
  iconSize4 = '0.5rem',
  iconSize5 = '0.4rem',
  iconSize01 = '2.25rem',

  fontWeightBolder = 600,
  fontWeightBold = 500,
  fontWeightRegular = 400,
  fontWeightLight = 300,
  fontWeightExtraLight = 200,

  lineHeight1 = '2.563rem',
  lineHeight2 = '2rem',
  lineHeight3 = '1.875rem',
  lineHeight4 = '1.75rem',
  lineHeight5 = '1.5rem',
  lineHeight6 = '1.25rem',
  lineHeight7 = '1.125rem',
  lineHeight8 = '1rem',
  lineHeight9 = '0.75rem',
  lineHeight10 = '2.375rem',
  lineHeight11 = '0.5rem',

  chevronIconMarginTop = '2px',
  projectModalWith = '325px',

  checkboxSize = '1.25rem',
}
